//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import datetime from '~/mixins/datetime'
import assets from '~/mixins/assets'

export default {
  mixins: [datetime, assets],
  props: {
    row: Object,
    notes: Boolean
  },
  computed: {
    link () {
      return this.row.file ? this.row.file.url : null
    },
    filename () {
      return this.row.name
    }
  }
}
